import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=7f2aa0c0&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=7f2aa0c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2aa0c0",
  null
  
)

export default component.exports